import { createAction, props } from '@ngrx/store';
import { AccountManagerDashboardFollowupType } from 'src/app/accountmanagers/dashboard/enums/account-manager-dashboard.enum';
import {
    AccountManagerDashboardFollowupItem,
    UserFollowupTimeBuckets
} from 'src/app/accountmanagers/dashboard/models/account-manager-dashboard-tile-followups.model';

export const getAccountManagerFollowups = createAction(
    '[Account Manager Component API] Get Followups',
    props<{ followupType: AccountManagerDashboardFollowupType; utcOffset: number }>()
);

export const getAccountManagerFollowupsSuccess = createAction(
    '[Account Manager Dashboard Component API] Get Followups success',
    props<{ followupType: AccountManagerDashboardFollowupType; followupItems: AccountManagerDashboardFollowupItem[] }>()
);

export const getAccountManagerFollowupsFail = createAction(
    '[Account Manager Dashboard Component API] Get Followups fail',
    props<{ error: string }>()
);

export const getAccountManagerFollowupsSummary = createAction(
    '[Account Manager Component API] Get Followups Summary',
    props<{ timezoneOffset: number }>()
);

export const getAccountManagerFollowupsSummarySuccess = createAction(
    '[Account Manager Dashboard Component API] Get Followups Summary success',
    props<{ data: UserFollowupTimeBuckets }>()
);

export const getAccountManagerFollowupsSummaryFail = createAction(
    '[Account Manager Dashboard Component API] Get Followups Summary fail',
    props<{ accountManagerSummaryError: string }>()
);
